import React, { FC, Fragment } from 'react';
import { useTheme } from '../../../../../theme';
import { useTranslation } from 'react-i18next';
import { CdnIcon, Filter } from '@shared/ui';
import { LocationSuggestionFragment } from '@websky/graphql';
import { useDirections } from '../../hooks';
import DropdownDirections from '../DropdownDirections/DropdownDirections';

interface Props {
	cities?: LocationSuggestionFragment[];
}

const DesktopDirections: FC<Props> = ({ cities }) => {
	const { DesktopDirections: css } = useTheme('TravellerForm');

	const { t } = useTranslation('Traveller');

	const { fields, ...model } = useDirections(cities);

	return (
		<div className={css.directions}>
			{fields.map((field, index) => (
				<Fragment key={field.queryFieldName}>
					<div className={css.field}>
						<DropdownDirections
							{...model}
							field={field}
							InputProps={{
								variant: 'labelOut',
								helperText: t('You have selected all available cities')
							}}
						/>

						<div className={css.selectedOptions}>
							{field.selectedOptions?.map(option => (
								<Filter
									key={option.value}
									label={option.label}
									isSelected
									icon={<CdnIcon icon="Action/Close-Clear" />}
									onClick={() => model.deleteOption(field.arrayFieldName, option)}
								/>
							))}
						</div>
					</div>

					{index === 0 && <div className={css.verticalLine} />}
				</Fragment>
			))}
		</div>
	);
};

export default DesktopDirections;
